<ng-container *transloco="let t">
  <div class="d-flex justify-content-center load-more-wrapper pt-3 pb-70-30">
    <a class="text-black fw-semibold text-uppercase" (click)="handleClick()">
      {{ t('app.common.load.more') }}
    </a>
  </div>
</ng-container>
